const host = 'https://api.itsmywords.ekatrin.info';

export default {
  loginUser: () => [host, 'login'].join('/'),
  logoutUser: () => [host, 'logout'].join('/'),
  registrationtUser: () => [host, 'signup'].join('/'),
  profile: () => [host, 'profile'].join('/'),
  sourceText: () => [host, 'sourceText'].join('/'),
  addUserWords: () => [host, 'userWords'].join('/'),
  getUserWords: () => [host, 'userWords'].join('/'),
  deleteUserWords: () => [host, 'deleteUserWords'].join('/'),
  updateUserWords: () => [host, 'userWords'].join('/'),
  audio: (wordId) => [host, 'audio', wordId].join('/'),
  userWordsStudied: (wordId) => [host, 'userWordStudied', wordId].join('/'),
};



// WEBPACK FOOTER //
// ./src/routes.js